import { safeFetch } from "../utils/safeFetch";

export const getAllVariants = async (token, tenant) => {
    const response = await safeFetch(`/api/variants`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        }
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

export const oneVariantById = async (id, token, tenant) => {
    const response = await safeFetch(`/api/variants/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        }
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

export const allVariantsById = async (productId, token, tenant) => {
    const response = await safeFetch(`/api/variants/by-product/${productId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        }
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

export const setVariantProducts = async (id, productIds, token, tenant) => {
    const response = await safeFetch(`/api/variants/${id}/products`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify({ productIds }),
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

export const createVariant = async (variant, token, tenant) => {
    const response = await safeFetch(`/api/variants`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(variant),
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

export const updateVariant = async (id, variant, token, tenant) => {
    const response = await safeFetch(`/api/variants/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(variant),
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

export const patchVariant = async (id, variant, token, tenant) => {
    const response = await safeFetch(`/api/variants/${id}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(variant),
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
};

export const deleteVariant = async (id, token, tenant) => {
    const response = await safeFetch(`/api/variants/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        }
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    try {
        const text = await response.text();
        return text ? JSON.parse(text) : null;
    } catch (err) {
        console.warn("Risposta non JSON:", err);
        return null;
    }
};
